(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["layout_catalog.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("layout.html", true, "layout_catalog.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n<div id=\"catalog\" class=\"view-panel-catalog\">\r\n    ";
if(runtime.contextOrFrameLookup(context, frame, "catalog_title") != null) {
output += "\r\n        <div id=\"catalog-title\" class=\"title-block\">\r\n            <h1>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "catalog_title"), env.opts.autoescape);
output += "</h1>\r\n            <span class=\"item-count\">(";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"length"), env.opts.autoescape);
output += ")</span>\r\n        </div>\r\n\r\n        <div id=\"catalog-tools\">\r\n            <div class=\"tools-row\">\r\n                <div class=\"tools-left\">\r\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "categories") != null) {
output += "\r\n                        <label id=\"categories-label\" for=\"categories-select\"></label>\r\n                        <select id=\"categories-select\">\r\n                            ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "categories");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
output += "\r\n                                <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"value"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_9),"name"), env.opts.autoescape);
output += "</option>\r\n                            ";
;
}
}
frame = frame.pop();
output += "\r\n                        </select>\r\n                    ";
;
}
output += "\r\n                </div>\r\n                <div class=\"tools-right\">\r\n                    ";
var t_10;
t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"rendezes") + "/" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"sorrend");
frame.set("sort_val", t_10, true);
if(frame.topLevel) {
context.setVariable("sort_val", t_10);
}
if(frame.topLevel) {
context.addExport("sort_val", t_10);
}
output += "\r\n                    <label id=\"sort-label\" for=\"sort-select\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by"), env.opts.autoescape);
output += "</label>\r\n                    <select id=\"sort-select\">\r\n                        <option value=\"nev/novekvo\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "nev/novekvo") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "sort_by.name_asc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"nev/csokkeno\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "nev/csokkeno") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "sort_by.name_desc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"datum/novekvo\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "datum/novekvo") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "sort_by.date_asc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"datum/csokkeno\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "datum/csokkeno") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "sort_by.date_desc"), env.opts.autoescape);
output += "</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"tools-row\">\r\n                <div class=\"tools-left\">\r\n                    <ul class=\"tools-flags\">\r\n                        <li><input id=\"filter-released\" type=\"checkbox\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"megjelent")) {
output += " checked";
;
}
output += "> <label id=\"label_released\" for=\"filter-released\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "filter.released"), env.opts.autoescape);
output += "</label></li>\r\n                        <li><input id=\"filter-free\" type=\"checkbox\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"ingyenes")) {
output += " checked";
;
}
output += "> <label id=\"label_free\" for=\"filter-free\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "filter.free"), env.opts.autoescape);
output += "</label></li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"tools-right\">\r\n                    <button id=\"btn-open-all\" type=\"button\" class=\"closeAll\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "action.open_all"), env.opts.autoescape);
output += "</button>\r\n                    <button id=\"btn-close-all\" type=\"button\" class=\"openAll\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "action.close_all"), env.opts.autoescape);
output += "</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div id=\"catalog-list\">\r\n            <ul>\r\n            ";
frame = frame.push();
var t_13 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("item", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\r\n                ";
context.getBlock("list_item")(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\r\n            ";
});
}
}
frame = frame.pop();
output += "\r\n            </ul>\r\n        </div>\r\n    ";
;
}
else {
output += "\r\n        <div id=\"catalog-title\" class=\"title-block\">\r\n            <h1>Hiba</h1>\r\n        </div>\r\n\r\n        <div id=\"catalog-list\">Nincs ilyen elem.</div>\r\n    ";
;
}
output += "\r\n</div>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_list_item(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_content: b_content,
b_list_item: b_list_item,
root: root
};

})();
})();
